import { subscribeToRequests } from '@lib/request-observer';
import mondaySdk from 'monday-sdk-js';
import { DEPLOY_APP_ID } from './public-view-event';

const OBSERVATION_WINDOW_MS = 2000;
const startTime = performance.now();

let started = false;
let wasTabHidden = false;

// The SPA shell is rendered on the server too, where there is no document.
if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) wasTabHidden = true;
  });
}

export function reportAppLoaded(): void {
  reportTime('load', { aiAppId: DEPLOY_APP_ID });
}

export function startTimeToInteractiveTracker(): void {
  if (started) return;
  started = true;

  const trackedRequests: Promise<unknown>[] = [];
  let lastSettledAt = startTime;

  const unsubscribe = subscribeToRequests((request) => {
    // then(fn, fn) instead of finally: finally's derived promise rejects with the request, and as
    // nothing handles it until allSettled it would surface as an unhandledrejection app error.
    const settled = () => {
      lastSettledAt = performance.now();
    };
    trackedRequests.push(request.then(settled, settled));
  });

  setTimeout(async () => {
    unsubscribe();

    await Promise.allSettled(trackedRequests);

    requestAnimationFrame(() => {
      const timeUntilDataLoaded = Math.round(lastSettledAt - startTime);
      const timeToSubtractFromEventDuration =
        timeUntilDataLoaded >= OBSERVATION_WINDOW_MS ? 0 : OBSERVATION_WINDOW_MS - timeUntilDataLoaded;

      reportTime('interactive', {
        aiAppId: DEPLOY_APP_ID,
        wasTabHidden,
        trackedRequests: trackedRequests.length,
        dataWaitDurationMs: timeToSubtractFromEventDuration,
      });
    });
  }, OBSERVATION_WINDOW_MS);
}

const monday = mondaySdk();

async function reportTime(...args: Parameters<(typeof monday)['reportTime']>): Promise<void> {
  if (!monday.reportTime) {
    return;
  }
  try {
    await monday.reportTime(...args);
  } catch {
    // best-effort telemetry
  }
}
